var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeaturesIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.728 52.083",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#594cda;}.cls-2{fill:#eb427e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "features-icon-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.4,0H65.2A3.2,3.2,0,0,1,68.63,2.894v46.3A3.2,3.2,0,0,1,65.2,52.083H10.854c-1.9,0-10.892-7.273-10.892-8.871V2.894A3.2,3.2,0,0,1,3.4,0ZM34.5,25.124L12.487,9.369,8.04,13.779,34.546,32.746,60.575,13.764,56.084,9.387,34.505,25.124h0Z",
    transform: "translate(0.099)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.312,31.238c-5.712,0-10.826,3.079-12.834,7.728l3.21,1.047c2-4.619,7.93-6.953,13.243-5.214,4,1.31,6.652,4.635,6.657,8.351,0,4.934-4.6,8.934-10.276,8.934H10.184c-5.676,0-10.279-3.994-10.283-8.928,0-3.795,2.753-7.177,6.871-8.434C6.445,28.972,11.54,24.08,18.153,23.795c5.651-.244,10.729,2.981,12.181,7.735A15.732,15.732,0,0,0,27.312,31.238Z",
    transform: "translate(0.099)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon1);
export default __webpack_public_path__ + "static/media/features-icon-1.718712766a9deede665ce398e608e772.svg";
export { ForwardRef as ReactComponent };